<template>
  <pi-content className="white">
    <div class="my-cash pi-flex-column">
      <div class="my-cash-info pi-flex-column pi-flex">
        <div class="my-cash-info-bottom-base pi-flex-column pi-flex-item text-color-white pi-flex-center-parent">
          <!--<div class="text-size-60">3456</div>-->
          <!--<div class="text-size-30">可退款(元)</div>-->
          <div class="text-size-28 margin-right-normal" style="align-self: flex-end; border-bottom: white 1px solid" @click="gotoCustomRefund">自定义退款</div>
        </div>
        <!--<div class="my-cash-info-bottom pi-flex padding-small text-size-24">-->
          <!--<div>可退余额3456元</div>-->
          <!--<div style="padding: 0 0.1rem">|</div>-->
          <!--<div>不可退款0元</div>-->
        <!--</div>-->
      </div>
      <van-list
        class="refund-list"
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
      >
        <div class="list-item pi-flex pi-divider" v-for="item in list" :key="item" :title="item">
          <img src="../../assets/img/d72e70cc40071d5964794636618a9d3.png">
          <div class="pi-flex-item padding-left-normal">
            <div class="text-size-32 text-color-second">充值{{item.rechargeAmount}}元</div>
            <div class="text-size-24 text-color-third margin-top-normal">{{item.rechargeTime}}</div>
          </div>
          <div>
            <div class="text-size-32 text-color-first" style="font-weight: 500">¥{{item.availbleRefundAmount}}</div>
            <div class="text-size-24 text-color-third margin-top-normal">可退款</div>
          </div>
        </div>
      </van-list>
      <div class="bottom-content">
        <div class="refund">
          <span class="text-size-28" style="border-bottom: currentColor 1px solid; line-height: 0.4rem">退款记录</span>
          <span>》</span>
        </div>
        <div class="button1" @click="allCash">一键退款</div>
        <div class="tip text-size-26 text-color-third">如有疑问请查看
          <a>退款说明</a>
          或直接
          <a>联系客服</a>
          。您还可以
          <a>自定义退款</a>
          ，即逐笔退款或者退款设置金额</div>
      </div>
    </div>
  </pi-content>
</template>

<script>
import { List } from 'vant';
import messageBox from '@/components/pi-message/pi-message.js';
import { batchRefund, getRefundRechargeList } from '@/common/api/index';
import { mapState } from 'vuex';
export default {
  name: 'my-cash',
  components: {
    [List.name]: List
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      userMoney: {},
      style: {},
      allLoaded: false,
      refundTotal: 0.00,
      currentPage: 0,
      pageSize: 10,
      thisPageCount: null
    };
  },
  methods: {
    onLoad() {
      this.getList();
    },
    loadBottom () {

    },
    gotoCustomRefund() {
      this.$router.push('/my/cash/custom');
    },

    async getList () {
      getRefundRechargeList({
        accountPkId: this.$testPkId,
        globalPageIndex: this.currentPage + 1,
        globalPageSize: this.pageSize,
        lastPageAmount: this.thisPageCount
      }).then((data) => {
        if (data.status === 0 && data.data) {
          console.log('fdf');
          if (this.currentPage === 0) {
            this.list = [];
          }
          this.currentPage++;
          for (let i = 0; i < data.data.length; i++) {
            if (i === 0) {
              this.thisPageCount = data.data[0].thisPageAmout;
            }
            this.list.push(data.data[i]);
          }

          // 加载状态结束
          this.loading = false;

          // 数据全部加载完成
          if (this.currentPage >= data.totalPage) {
            this.finished = true;
            console.log('fdf8');
          }
        }
      }).catch((error) => {
        console.log(error);
        this.loading = false;
      });
    },
    async getUser () {
    },
    allCash () {
      messageBox({
        title: '',
        text: '是否确认提交退款申请？提交后退款金额将会原路返回到您的支付宝账户，您可以在退款记录查看退款信息。',
        confirm: async () => {
          // let operatorInfo = this.app.operatorInfo;
          // let ret;
          // if (operatorInfo.refundType === 0) {
          //   // 0 自动退款
          //   ret = await batchRefundRecord({ refundType: operatorInfo.refundType });
          // } else {
          //   // 1 手动退款
          //   ret = await manualBatchRefundRecord({ refundType: operatorInfo.refundType });
          // }
          // if (ret.status === this.$config.ajaxStatus) {
          //   let operatorInfo = this.app.operatorInfo;
          //   let text;
          //   if (operatorInfo.refundType === 0) {
          //     text = '提交成功，资金将原路返回到您的支付账户，可在退款记录查看退款信息。';
          //   } else {
          //     text = '提交成功，等待平台审核成功后，资金将原路返回到您的支付账户，可在退款记录查看退款信息。';
          //   }
          //   messageBox({
          //     title: '',
          //     confirmActive: true,
          //     confirmText: '是',
          //     cancelText: '否',
          //     text: text,
          //     confirm: () => {
          //
          //     }
          //   });
          //
          //   this.getUser();
          // } else {
          //   this.$toast(ret.msg);
          // }
          batchRefund({
            'accountPkId': this.$testPkId
          }).then((data) => {
            if (data.status === 0) {
              this.$toast('提交成功');
            } else {
              this.$toast(data.msg);
            }
          }).catch((error) => {
            console.log(error);
            this.$toast('提交失败');
          });
        },
        cancel: () => { }
      });
    }
  },
  mounted () {
    // this.getList();
    // this.getUser();
    // this.$nextTick(() => {
    //   let cashInfo = this.$refs.cashInfo.offsetHeight;
    //   let height = this.$common.getWinHeight() - cashInfo;
    //
    //   this.style = { height: (height) + 'px' };
    // });
  },
  destroyed () {
    this.$common.removeBodyBg();
  },
  computed: {
    ...mapState(['app'])
  }
};
</script>

<style lang="less" scoped>
.my-cash {
  .my-cash-info {
    width: 100%;
    height: 2.7rem;
    background: url("../../assets/img/bg_refund_top.png");
    background-size: 100%;
    .my-cash-info-bottom-base{
      margin-top: 0.43rem;
    }
    .my-cash-info-bottom {
      color: #F7F7F7;
      background-color: rgba(0,0,0,0.1);;
    }
  }
  .refund-list {
    position: fixed;
    top: 2.7rem;
    bottom: 2.1rem;
    left: 0;
    right: 0;
    overflow-y: scroll;
    .list-item {
      margin: 0 0.2rem;
      padding: 0.2rem 0;
      img {
        width: 0.8rem;
        height: 0.8rem;
      }
    }
  }
  .bottom-content {
    position: fixed;
    height: 2.5rem;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .refund {
      color: #6FA1F6;
      text-align: right;
    }
    a {
      color: #14C4F5;
      border-bottom: #14C4F5 1px solid;
    }
    .tip {
      padding: 0.1rem 0.2rem;
    }
  }
  .button1{
    height: 0.8rem;
    background:rgba(20,204,128,1);
    border-radius:40px;
    text-align: center;
    color: white;
    font-size: 0.34rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.2rem;
  }
}
</style>
